import { useLocation } from "@tanstack/react-router";
import { OrganizationSwitcher, UserButton } from "@clerk/react";

import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
} from "@/components/ui/navigation-menu";

import { SupportDialog } from "@/components/support/support-dialog";
import { cn } from "cn";
import logo_light from "/logo_light.svg";

const navigation = [
  {
    name: "Appointments",
    href: "/",
  },
  {
    name: "Sales",
    href: "/sales",
  },
  {
    name: "Clients",
    href: "/clients",
  },
  {
    name: "Staff",
    href: "/staff",
  },
  {
    name: "Products",
    href: "/products",
  },
  {
    name: "Services",
    href: "/services",
  },
];

export function MainNavigation() {
  const location = useLocation();
  const pathname = location.pathname;

  const isActiveRoute = (href: string) => {
    if (href === "/") {
      return pathname === "/";
    }
    return pathname.startsWith(href);
  };

  return (
    <nav className="border-b py-4 relative">
      <div className="container mx-auto px-4">
        <div className="absolute left-4 top-1/2 -translate-y-1/2">
          <a href="/">
            <img src={logo_light} alt="logo" className="h-12" />
          </a>
        </div>

        <div className="flex justify-center text-accent-foreground">
          <NavigationMenu>
            <NavigationMenuList>
              {navigation.map((item) => {
                const isActive = isActiveRoute(item.href);

                return (
                  <NavigationMenuItem key={item.name}>
                    <NavigationMenuLink asChild>
                      <a 
                        href={item.href}
                        className={cn(
                          "flex items-center px-4 py-2 hover:font-semibold",
                          isActive && "font-semibold text-foreground"
                        )}
                      >
                        {item.name}
                      </a>
                    </NavigationMenuLink>
                  </NavigationMenuItem>
                );
              })}
            </NavigationMenuList>
          </NavigationMenu>
        </div>

        <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center gap-3">
          <SupportDialog />
          <OrganizationSwitcher hidePersonal />
          <UserButton />
        </div>
      </div>
    </nav>
  );
}
